import { type VariableValue } from "@doitintl/cmp-models/src/CloudFlowVariables";

import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../Components/FilterTable/filterTableUtils";

const itemsDescriptions: FilterTableItemDescriptor<VariableValue>[] = [
  {
    headerText: "Name",
    value: "name",
    filterType: "string",
  },
  {
    headerText: "Value",
    value: "value",
    filterType: "string",
  },
  {
    headerText: "Created By",
    value: "owner",
    filterType: "string",
  },
  {
    value: "@",
    headerText: "",
  },
];

export const { headerColumns, filters } = generateHeadersAndFilters(itemsDescriptions);
